<template>
  <div class="scroll-vertical full-height big-spacer related-files">
    <div v-for="file in files" :key="file.path" class="spacer">
      <alert-log-file :file="file" :related="related"></alert-log-file>
    </div>
  </div>
</template>

<script>
import AlertLogFile from '@/components/alertlogs/AlertLogFile.vue';

export default {
  name: 'AlertRelatedFiles',
  components: {
    AlertLogFile,
  },
  props: {
    files: {
      type: Array,
      required: true,
    },
    related: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.spacer {
  margin-bottom: 1rem;
}

.big-spacer {
  padding-bottom: 8rem;
}

.full-height {
  height: 100%;
}
</style>
